import React from 'react';
import FOEELogo from '../foee-01.png';
import FOEELogoWhite from '../FOEE-small-white.png';
import URShield from '../shield_ur.svg';
import VCUSeal from '../vcu-mobile.png';
import './Icons.css';

const Icons = () => {
  return (
    <div className='icons'>
      <a
        href='https://www.richmond.edu/'
        target='_blank'
      >
        <img src={URShield} alt="University of Richmond Shield" />
      </a>
      <a
        href='https://www.vcu.edu/'
        target='_blank'
      >
        <img src={VCUSeal} alt="Virginia Commonwealth University Seal" />
      </a>
      <a
        href='https://friendsofeastend.com/'
        target='_blank'
      >
        <img src={FOEELogo} alt="Friends of East End Logo" className='foeeblack' />
        <img src={FOEELogoWhite} alt="Friends of East End Logo"  className='foeewhite' />
      </a>
    </div>
  );
};

export default Icons;



// WEBPACK FOOTER //
// ./src/components/Icons.jsx